"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVariantClassNames = void 0;
var IconBase_1 = require("./IconBase");
var icon_secondary_module_scss_1 = __importDefault(require("./icon-secondary.module.scss"));
var getVariantClassNames = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? IconBase_1.defaultProps.variant : _b;
    return ({
        primary: icon_secondary_module_scss_1.default["icon-secondary--".concat(variant, "-primary")],
        secondary: icon_secondary_module_scss_1.default["icon-secondary--".concat(variant, "-secondary")]
    });
};
exports.getVariantClassNames = getVariantClassNames;
